import { create } from 'zustand';

interface ModalStoreState {
  activeModal: string | null;
  entityId: string | null;
  fieldOverrides: Record<string, unknown>;
  pendingAction: string | null;
  actionArgs: Record<string, unknown>;

  openModal: (modal: string, opts?: {
    entityId?: string;
    fields?: Record<string, unknown>;
    action?: string;
    actionArgs?: Record<string, unknown>;
  }) => void;
  closeModal: () => void;
  clearAction: () => void;
}

export const useModalStore = create<ModalStoreState>((set) => ({
  activeModal: null,
  entityId: null,
  fieldOverrides: {},
  pendingAction: null,
  actionArgs: {},

  openModal: (modal, opts) =>
    set({
      activeModal: modal,
      entityId: opts?.entityId ?? null,
      fieldOverrides: opts?.fields ?? {},
      pendingAction: opts?.action ?? null,
      actionArgs: opts?.actionArgs ?? {},
    }),

  closeModal: () =>
    set({
      activeModal: null,
      entityId: null,
      fieldOverrides: {},
      pendingAction: null,
      actionArgs: {},
    }),

  clearAction: () =>
    set({
      pendingAction: null,
      actionArgs: {},
    }),
}));
